import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=ae644162&scoped=true&"
import script from "./PdfViewer.vue?vue&type=script&lang=js&"
export * from "./PdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=ae644162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae644162",
  null
  
)

export default component.exports